export default "__VITE_ASSET__Bxm6LJOA__"